module.exports = __webpack_public_path__ + "media/images/bg/hero/bialoleka-pricing-904263ca274e61e79a23249f3576e136.webp";